import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ConfirmComponent, Context, GlobalInfo, Static, Tarea, Usuario } from '@app/shared';
import { LocalDataSource } from 'ng2-smart-table';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { AssignationTaskService } from './shared/assignation-task.config.service';
import { ToastrService } from 'ngx-toastr';
import { AssignationTaskDataService } from './shared/assignation-task.data.service';
import { NotifierService } from '@app/shared/services/notifier.service';

@Component({
  selector: 'iw-assignation-responsable-utility',
  templateUrl: './assignation-task.component.html',
  styleUrls: ['./assignation-task.component.scss'],
  providers: [
    AssignationTaskDataService,
    AssignationTaskService
  ]
})
export class AssignationTaskComponent implements OnInit {
  // Contexto del formulario, es suministrado dinámicamente
  @Input() ctx: Context;
  // Evento para finalizar y cerrar la modal, es suministrado dinámicamente
  @Input() event: EventEmitter<any>;
  // Define si es una asignacion para finalizar la acarga de datos
  @Input() finishDataLoad = false;
  // Determina si el usuario en sesion es responsable de la tarea
  @Input() userResponsible = false;
  // Define si la tarea esta finalizada
  @Input() finishTask = false;
  // Tarea actual
  @Input() task: Tarea;
  // Define si hay una secundaria iniciada
  @Input() secondaryActive = false;
  // Contiene el id del grupo seleccionado
  rolId = -1;
  // Contiene los grupos seleccionados
  rolList:any[] = [];
  // Referencia a la dependencia seleccionada
  selectedRol: any;
  // Determina si se esta realizando alguna petición al backend para roles
  loadingRols = false;
  // Determina cuando esta consultando los usuarios del grupo
  isLoading = false;
  // Determina cuando esta consultando los usuarios del grupo
  isLoadingUser = false;
  // Usuarios del rol(grupo) seleccionado
  users: Usuario[] = [];
  // responsables a asignar o eliminar
  responsables: any[] = [];
  // Referencia a los usuarios seleccionados
  selectedFunctionaries: any[] = [];
  // Información global de la app
  gi: Partial<GlobalInfo>;
  // contiene la configuracion de la tabla
  settings = {};
  // Datos para llenar la tabla de historial de asignaciones
  source: LocalDataSource;
  // Datos para llenar la tabla dfe usuarios del grupo
  sourceUser: LocalDataSource;
  // contiene la configuracion de la tabla
  settingsUsers = {};
  // Referencia de la modal
  modalRef: BsModalRef;
  //Referencia para habilitar el selector de responsables para agregar
  addResponsable: boolean =  false;
  // validación para el botón asignar
  asignButton: boolean = false;
  // validación para el botón borrar
  deleteButton: boolean = false;
  //COPIA DEL OBJETO TASK
  internalTask: Tarea;
  // Valida si la tarea es de tipo asignación
  asign: boolean = false;
  // define cuando cerrar o mostrar el furmulario
  @Output() frmOpen: EventEmitter<boolean> = new EventEmitter();
  // Referencia al componente de confirmación
  @ViewChild('confirmFinish') private confirmFinish: ConfirmComponent;

  constructor(
    private iti: AssignationTaskDataService,
    private toastr: ToastrService,
    private ns: NotifierService,
  ) { }

  ngOnInit() {
    if (this.finishDataLoad) {
      this.userResponsible = true;
    }
    this.loadingRols = true;
    this.rolList = [];
    this.iti.getRoles().subscribe(r => {
      r.forEach(element => {
        this.rolList.push({id:element.id,nombre:element.nombre});
      });
    // Se inicia la configuracion de la tabla
    this.internalTask = Static.copyObjet(this.task);
    const configTable = new AssignationTaskService();
    this.settingsUsers = configTable.getSettingsTableAssignment();
    if(this.task.tarea_tipo.nombre == "asignacion"){
      this.asign = true;
    }
    this.sourceUser = new LocalDataSource([]);
    this.loadingRols = false;
    
    });
  }

  /**
   * Consulta los usuarios del rol(grupo) seleccionado.
   *
   * @param {any} role
   * @memberof AssignationTaskComponent
   */
  chooseRole(role: any) {
    if (this.rolId !== role) {
      this.isLoadingUser = true;
      this.rolId = role;
      this.sourceUser = new LocalDataSource([]);
      this.iti.getRole(role).subscribe(r => {
        let users: any[] = [];
        if (r.rol_user && r.rol_user.length) {
          r.rol_user.forEach((user, i) => {
            users.push({id:user.id,nombre:user.first_name, apellidos:user.last_name});
          });
          this.sourceUser = new LocalDataSource(users);
          this.sourceUser.refresh();
        }
        this.isLoadingUser = false;
      });
    }
  }

    /**
   *Controla cuando el usuario da click sobre la tabla
   *Añade un funcionario a la lista de funcionarios a asignar
   * @param {*} data
   * @memberof AssignationTaskComponent
   */
   clikRowSelect(data: any) {
    let exist = false;
    this.selectedFunctionaries.forEach(sf=>{
      if(sf.id == data.data.id){
        exist = true;
      }
    })
    if(!exist){
      exist = false;
      let index = 0;
      this.responsables.forEach((rs, i)=>{
        if(rs.usuario_id == data.data.id && rs.accion == 'eliminar'){
          exist = true;
          index = i;
        }
      })
      if(exist){
        this.responsables.splice(index, 1);
        this.selectedFunctionaries.push(data.data);
      }else{
        let responsible = {usuario_id: data.data.id, accion: 'crear'};
        this.responsables.push(responsible);
        this.selectedFunctionaries.push(data.data);
      }
    }
  }

  /**
   *Elimina un funcionario de la lista de asignaciones
   *
   * @param {Usuario} user
   * @memberof AssignationTaskComponent
   */
   dropFunctionary(user: Usuario) {
    let index = this.selectedFunctionaries.indexOf(user);
    this.selectedFunctionaries.splice(index, 1);
    let accion = 'eliminar';
    if(this.responsables.length){
      this.responsables.forEach((rs, i)=>{
        if(rs.usuario_id == user.id && rs.accion == 'crear'){
          index = i
          accion = rs.accion;
        }
      });
    }
    if(accion == 'eliminar'){
      let responsible = {usuario_id: user.id, accion: 'eliminar'};
      this.responsables.push(responsible);
    }
    if(accion == 'crear'){
      this.responsables.splice(index, 1);
    }
  }

  /**
   * Evento que finaliza la tarea.
   *
   * @memberof AssignationTaskComponent
   */
  finish(confimation?: boolean) {
    if (confimation) {
      this.isLoading = true;
      const responsibles: number[] = [];
      this.responsables.forEach(r => {
        responsibles.push(r.usuario_id);
      });
      this.iti.createAssignmentTask(this.task.id,responsibles).then(()=>{
        this.isLoading = false;
        this.responsables.length = 0;
        this.responsables = [];
        this.selectedFunctionaries.length = 0;
        this.selectedFunctionaries = [];
        this.frmOpen.emit(true);
      }).catch(() => {
        this.isLoading = false;
        this.responsables.length = 0;
        this.responsables = [];
        this.selectedFunctionaries.length = 0;
        this.selectedFunctionaries = [];
      });
      
    }
  }

  /**
   * Validad que la tarea se pueda finalizar
   *
   * @memberof AssignationTaskComponent
   */
   finishConfirm() {
    if (this.responsables.length && this.userResponsible && !this.finishTask && !this.secondaryActive) {
      this.confirmFinish.open();
    }else {
      if (!this.userResponsible) {
        this.toastr.error('Usted no posee los permisos suficientes para ejecutar esta acción.', 'Permiso denegado');
      } else if (this.finishTask) {
        this.toastr.error('La tarea ya está finalizada.', 'Acción no permitida');
      } else if (this.secondaryActive) {
        this.toastr.error(
          'No se puede realizar esta acción debido a que se encuentra un procesos secundario en progreso.',
          'Acción no permitida'
        );
      } else if (!this.responsables.length) {
          this.toastr.error('Debe seleccionar al menos un responsable.', 'Información incompleta');
      } else {
        this.toastr.error(
          'Lo sentimos ha ocurrido un error inesperado, inténtalo de nuevo más tarde.',
          'Error inesperado'
        );
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/administration/utilitarios-management/utilitarios-flow/assignation-task/assignation-task.component.ts